// ----------------------------------------------------------------------
// <copyright file="Izenda.FontSettingsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var AlignmentSetting = require('share/components/controls/Izenda.AlignmentSetting');
  var Font = require('share/components/controls/Izenda.Font');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Constants = require('logic/data/Izenda.UIConstants');
  var localizer = require('share/localization/Izenda.Localizer');
  var ALIGNMENT_DEFAULT = 'alignLeft';

  var FontSettingsPopup = React.createClass({
    propTypes: {
      save: React.PropTypes.func,
      close: React.PropTypes.func,
      font: React.PropTypes.object,
      title: React.PropTypes.string
    },

    getInitialState: function () {
      var font = this.props.font;
      return {
        font: {
          style: {
            fontBold: font.fontBold,
            fontItalic: font.fontItalic,
            fontUnderline: font.fontUnderline
          },
          format: {
            fontFamily: font.fontFamily || Constants.fontFamily.proxima,
            fontSize: font.fontSize || Constants.fontSize[0]
          },
          color: font.fontColor || Constants.textColor,
          backgroundColor: font.fontHighlightColor
        },
        alignment: font.alignment || ALIGNMENT_DEFAULT
      }
    },

    closePopup: function (type) {
      var state = this.state;
      var font = state.font;
      var format = font.format;
      var style = font.style;
      if (type === 'accept') {
        this.props.save({
          fontFamily: format.fontFamily,
          fontSize: format.fontSize,
          fontBold: style.fontBold,
          fontItalic: style.fontItalic,
          fontUnderline: style.fontUnderline,
          fontColor: font.color,
          fontHighlightColor: font.backgroundColor,
          alignment: state.alignment
        });
        this.props.onAccept();
      } else {
        this.props.onReject();
      }
    },

    handleFontChanged: function (font) {
      this.setState({
        font: font.value
      });
    },

    handleAlignmentChanged: function (alignment) {
      this.setState({
        alignment: alignment.value
      });
    },

    renderContainer: function () {

      var state = this.state;
      return (
          <GridLayout>
            <GridLayout.Row>
              <GridLayout.Col cols={3}>
                <span>{localizer.getText("FONT_SETTINGS_LABEL_FONT")}</span>
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <Font value={state.font} onChange={this.handleFontChanged} />
              </GridLayout.Col>
            </GridLayout.Row>
            <GridLayout.Row>
              <GridLayout.Col cols={3}>
                <span>{localizer.getText("FONT_SETTINGS_LABEL_ALIGNMENT")}</span>
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <AlignmentSetting value={state.alignment} onChange={this.handleAlignmentChanged}/>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
      )
    },

    render: function () {

      var props = this.props;

      return (
        <Popup visible onClosed={this.closePopup} type='none' sizeClass="modal-xsm">
          <Popup.Header title={props.title} />
            <Popup.Body>
              {this.renderContainer()}
            </Popup.Body>
            <Popup.Footer>
              <Popup.ConfirmationButton type='accept'>{localizer.getText("COMMON_LABEL_OK")}</Popup.ConfirmationButton>
              <Popup.ConfirmationButton type='cancel'>{localizer.getText("COMMON_LABEL_CANCEL")}</Popup.ConfirmationButton>
            </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = FontSettingsPopup;

}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonPopup/Izenda.FontSettingsPopup.jsx